/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon32Regular = forwardRef('CopyIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 0A5.5 5.5 0 0 0 4 5.5v17A5.5 5.5 0 0 0 9.5 28h11a5.5 5.5 0 0 0 5.5-5.5v-17A5.5 5.5 0 0 0 20.5 0h-11ZM6 5.5A3.5 3.5 0 0 1 9.5 2h11A3.5 3.5 0 0 1 24 5.5v17a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 6 22.5v-17Z" }),
        React.createElement("path", { d: "M30 13a1 1 0 1 0-2 0v10a7 7 0 0 1-7 7h-9a1 1 0 1 0 0 2h9a9 9 0 0 0 9-9V13Z" })));
});
